import { Grid } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import NotFound from './NotFound.svg'

export const NotFoundPage = () => {
  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      justifyContent='center'
      style={{ minHeight: '75vh' }}
    >
      <Grid item xs={6}>
        <img src={NotFound} alt='not found page illustration' />
      </Grid>
      <Grid item xs={6}>
        <Link className='text-white font-weight-medium' to='/'>Take me back</Link>
      </Grid>
    </Grid>
  )
}

export default NotFoundPage
